import { IRequest } from "@uxland/harmonix";
import { IUserInfo } from "./model";

export class GetUserInfo implements IRequest<IUserInfo> {}
